import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import './../../components/Account/Login.css'

export default function VerifyEmailPage() {

  return (
    <React.Fragment>
      <section className="section__top section--green">
        <div className="wrapper__form">
          <div className="login">
            <div className="cardLogin">
              <div className="cardLogin__header">
                <h4 className="cardLogin__title">Verificación de cuenta</h4>
                <p className="cardLogin__text"><Link to="/login" className="cardLogin__link" title="Iniciar sesión">Inicia sesión aquí</Link></p>
                <div className="cardLogin__formGroup" style={{marginTop: '2rem'}}>
                  <div className="cardLogin__invalid cardLogin__invalidSuccess" role="alert">
                    Cuenta verificada correctamente.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="cardLogin__shape">
        <div className="cardLogin__shapeBotton">
          <svg viewBox="0 0 3000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 1000V583.723L3000 0V1000H0Z" fill="#fff"></path>
          </svg>
        </div>
      </div>
    </React.Fragment>
  )
}
